import Vue from "vue";
import Vuetify from "vuetify/lib/framework";
import config from "@/config";
import store from "../store";

Vue.use(Vuetify);

export default new Vuetify({
  rtl: store.state.isRTL,
  treeShake: true,
  options: {
    // Exposes the theme as --v-<color>-base variables, read by src/styles/main.scss.
    customProperties: true,
  },
  theme: {
    dark: store.state.dark,
    themes: {
      light: { ...config.colors, background: config.colors.lightBackground },
      dark: { ...config.colors, background: config.colors.darkBackground },
    },
  },
});
